import { type App, type Plugin } from 'vue';
import { storeToRefs } from 'pinia';

import { License } from '../models';
import { useAuthorizationStore } from '../stores';
import { type CorePluginOptions } from './corePluginOptions';

export const setupAuthorization: (options?: CorePluginOptions) => Plugin = (_options?: CorePluginOptions) => {
    return {
        install: (app: App): void => {
            const { licenses, organizationFlags } = storeToRefs(useAuthorizationStore());

            app.config.globalProperties.$l = (required: License[], operator: 'and' | 'or' = 'and'): boolean => {
                if (operator === 'and') {
                    return required.every(license => licenses.value.includes(license));
                }
                return required.some(license => licenses.value.includes(license));
            };
            app.config.globalProperties.$of = (flags: number, operator: 'and' | 'or' = 'and'): boolean => {
                if (operator === 'and') {
                    return (flags & organizationFlags.value) === flags;
                }
                return (flags & organizationFlags.value) !== 0;
            };
        }
    };
};